import { metaResolver } from "resolvers";

const forgotPasswordPageResolver = (data) => {
  return {
    meta: metaResolver(data.meta),
  };
};

export default forgotPasswordPageResolver;
